 import React from 'react'
import styled from 'styled-components'
import FirmaTextUpdateInput from '../../shared/firmalarim/firmaUpdateInputs/FirmaTextUpdateInput'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import FirmaPhoneUpdateInput from '../../shared/firmalarim/firmaUpdateInputs/FirmaPhoneUpdateInput'
import FirmaNumberUpdateInput from '../../shared/firmalarim/firmaUpdateInputs/FirmaNumberUpdateInput'
import FirmaIlUpdateInput from '../../shared/firmalarim/firmaUpdateInputs/FirmaIlUpdateInput'
import FirmaIlceUpdateInput from '../../shared/firmalarim/firmaUpdateInputs/FirmaIlceUpdateInput'
import locationData from "../../../utils/locationData/locationOptions";
import iller from "../../../utils/iller";
import { handleActiveSelect } from '../../../features/layout/layoutSlice'
import RotaTextUpdateInput from '../../shared/firmalarim/rotaUptadeInputs/RotaTextUpdateInput'
import RotaIlceUpdateInput from '../../shared/firmalarim/rotaUptadeInputs/RotaIlceUpdateInput'
import RotaPhoneUpdateInput from '../../shared/firmalarim/rotaUptadeInputs/RotaPhoneUpdateInput'
import RotaYetkiliUpdateInput from '../../shared/firmalarim/rotaUptadeInputs/RotaYetkiliUpdateInput'
import RotaKonumUpdateInput from '../../shared/firmalarim/rotaUptadeInputs/RotaKonumUpdateInput'
import Button from "../../shared/button/Btn"
import YetkiliTextUpdateInput from '../../shared/firmalarim/yetkiliUpdateInputs/YetkiliTextUpdateInput'
import YetkiliPhoneUpdateInput from '../../shared/firmalarim/yetkiliUpdateInputs/YetkiliPhoneUpdateInput'
import { firmalarimUpdate, setFirmaSelectRouteForMap, setIsDetailOpen } from '../../../features/firma/FirmaSlice'
import RotaIlUpdateInput from '../../shared/firmalarim/rotaUptadeInputs/RotaIlUpdateInput'
import { showNestedModal } from '../../../features/modal/modalSlice'

const Container = styled.div`
    width: 100%;
    height: 100%;
    .inputs{
        width: 100%;
        .title{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
                margin-bottom: 10px;
        }
        .col{
            display: flex;
            flex-direction: column;
            width: 80%;
            margin: 0 auto;
            margin-bottom: 20px;
            .row{
                display: flex;
                align-items: center;
                margin-block: 10px;
                width: 100% !important;
                .map{
                    padding: 5px;
                    color: var(--color-main);
                    background-color: transparent;
                    border-radius: 5px;
                    border: 1px solid var(--color-main);
                    display: inline-block;
                    margin-top: 5px;
                    cursor: pointer;
                    font-size: var(--font-size-sm);
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
        .rotalar{
            display: flex;
            flex-direction: column;
            width: 80%;
            margin: 0 auto;
        }
        .btns{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 70%;
            margin: 0 auto;
        }
    }
    .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .custom-width{
        width: 100% !important;
    }
`

const FirmaUpdate = () => {
    const {theme} = useSelector((state)=> state.layout)
    const {updatedFirmalarimData} = useSelector((state)=> state.firma)
    const {yetkili, routePoints} = updatedFirmalarimData
    const dispatch = useDispatch()
    const {topBarCompanyInfo} = useSelector((state)=> state.companyProfile)

    const handleUpdate = () => {
        dispatch(firmalarimUpdate(updatedFirmalarimData))
    }


  return (
    <Container onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)); }}>
        <div className='container'>
            <div className="inputs">
                <div onClick={(e) => { e.stopPropagation(); }} className="col">
                    <p className='title'>Firma Bilgileri</p>
                    <div className="row">
                        <FirmaTextUpdateInput inputWidth="100%" labelText="Firma Adı / Ünvanı" type="text" keyData="companyName" name="companyName" data={updatedFirmalarimData.companyName} />
                    </div>
                    <div className="row">
                        <FirmaPhoneUpdateInput inputWidth="100%" labelText="Firma Telefon No" keyData="companyPhone" name="companyPhone" data={updatedFirmalarimData.companyPhone} />
                    </div>
                    <div className="row">
                        <FirmaTextUpdateInput inputWidth="100%" labelText="Firma Mail Adresi" type="mail" keyData="companyMail" name="companyMail" data={updatedFirmalarimData.companyMail} />
                    </div>
                    <div className="row">
                        <FirmaTextUpdateInput inputWidth="100%" labelText="Vergi Dairesi" type="text" keyData="companyTaxOffice" name="companyTaxOffice" data={updatedFirmalarimData.companyTaxOffice} />
                    </div>
                    <div className="row">
                        <FirmaNumberUpdateInput inputWidth="100%" labelText="Vergi No" type="text" keyData="companyTaxNo" name="companyTaxNo" data={updatedFirmalarimData.companyTaxNo} />
                    </div>
                    <div className="row">
                        <FirmaIlceUpdateInput inputWidth="100%" options={locationData} labelText="İl/İlçe" type="text" keyData="companyCityAndTown" name="companyCityAndTown" data={updatedFirmalarimData.companyCityAndTown} />
                    </div>
                </div>

                <div className="col">
                    <p className='title'>Yetkili Bilgileri</p>
                    <div className="row">
                        <YetkiliTextUpdateInput inputWidth="100%" labelText="Yetkili Adı / Soyadı" type="text" keyData="officialName" name="officialName" data={yetkili.officialName} />
                    </div>
                    <div className="row">
                        <YetkiliPhoneUpdateInput inputWidth="100%" labelText="Yetkili Telefonu" keyData="officialPhone" name="officialPhone" data={yetkili.officialPhone} />
                    </div>
                    <div className="row">
                        <YetkiliTextUpdateInput inputWidth="100%" labelText="Yetkili Mail Adresi" type="mail" keyData="officialMail" name="officialMail" data={yetkili.officialMail} />
                    </div>
                </div>

                <div className="rotalar">
                    <p className='title'>Yükleme/Boşaltma Noktaları</p>
                    {routePoints.map((item,i)=>(
                        <div className="col custom-width">
                            <div className="row">
                                <RotaTextUpdateInput isCompanyName companyName={topBarCompanyInfo.companyShortName} inputWidth="100%" type="text" keyData="addressName" name={`addressName${i}`} labelText="Adres Adı" data={item} />
                            </div>
                            <div className="row">
                                <RotaIlceUpdateInput inputWidth="100%" options={locationData} type="text" keyData="cityAndTown" name={`cityAndTown${i}`} labelText="İl/İlçe" data={item} />
                            </div>
                            <div className="row flex" onClick={() => {dispatch(showNestedModal("firmalarimUpdateMapModal")); dispatch(setFirmaSelectRouteForMap(item));}}>
                                <RotaKonumUpdateInput inputWidth="60%" type="text" keyData="routeLocation" name={`routeLocation${i}`} labelText="Konum" data={item} />
                                <span className="map">Haritadan Konum Seç</span>
                            </div>
                            <div className="row">
                                <RotaYetkiliUpdateInput inputWidth="100%" type="text" name={`storageOfficialName${i}`} labelText="Depo Yetkilisi Adı" data={item} />
                            </div>
                            <div className="row">
                                <RotaPhoneUpdateInput inputWidth="100%" name={`storageOfficialPhone${i}`} labelText="Depo Yetkilisi Telefonu" data={item} />
                            </div>
                        </div>
                    ))}
                </div>
                <div className="btns">
                    <Button width="150px" color="#E85446" padding="10px" handleClick={handleUpdate} >Güncelle</Button>
                    <Button handleClick={()=>dispatch(setIsDetailOpen())} width="150px" color="#E85446" padding="10px">Kapat</Button>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default FirmaUpdate